"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.initialState = exports.types = exports.MOVEMENTS = exports.DEFAULT_FIXED = void 0;
/* eslint-disable default-param-last */
const deepmerge_1 = __importDefault(require("deepmerge"));
const HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
exports.DEFAULT_FIXED = 'Default';
exports.MOVEMENTS = {
    NONE: 'none',
    UP: 'up',
    DOWN: 'down',
};
exports.types = {
    SET_HEADER_LOCATION: 'HEADER/SET_LOCATION',
    SETUP_HEADER_PROPS: 'HEADER/SETUP_HEADER_PROPS',
    /* JSON LOGIC */
    GET_HEADER_INFO: 'HEADER/GET_HEADER_INFO',
    SET_SECTION_MENU: 'HEADER/SET_SECTION_MENU',
    SET_MOVISTAR_MENU: 'HEADER/SET_MOVISTAR_MENU',
    SET_SECTION_MENU_EMP: 'HEADER/SET_SECTION_MENU_EMP',
    SET_MOVISTAR_MENU_EMP: 'HEADER/SET_MOVISTAR_MENU_EMP',
    SET_FOOTER_INFO: 'FOOTER/SET_FOOTER_INFO',
    GET_FOOTER_INFO: 'FOOTER/GET_FOOTER_INFO',
    /* SEARCHER */
    RESET_SEARCHER: 'HEADER/RESET_SEARCHER',
    // JS LOGIC
    SET_SUGGESTED_INPUTS: 'HEADER/SET_SUGGESTED_INPUTS',
    GET_RELATED_PAGES: 'HEADER/GET_RELATED_PAGES',
    SET_RELATED_PAGES: 'HEADER/SET_RELATED_PAGES',
    // APIS
    SET_SEARCH_ENGINE: 'HEADER/SET_SEARCH_ENGINE',
    GET_SEARCHER_INFO: 'HEADER/GET_SEARCHER_INFO',
    SET_SEARCHER_INFO: 'HEADER/SET_SEARCHER_INFO',
};
exports.initialState = {
    /* about place */
    segment: 'particulares',
    location: {
        host: null,
        pathname: null,
    },
    /* about user */
    fullName: '',
    userType: '',
    isPriority: false,
    isEmpleado: false,
    isBuyProcess: false,
    isGestor: false,
    /* about scroll */
    scrollMovement: exports.MOVEMENTS.NONE,
    isSomethingFixed: false,
    lastScrollY: 0,
    /* about app */
    visible: true,
    blockedInicio: false, // if 4P iframe fails, this var become true.
    fullInfo: null, // every info ehader.json and headerEmp.json
    info: null, // all available info to work
    movistarMenuInfo: null, // info to build Movistar menu
    sectionMenu: null, // info to build pills, title, backlink, etc..
    movistarMenuInfoEmp: null, // info to build Movistar menu
    sectionMenuEmp: null, // info to build pills, title, backlink, etc..
    // fixed type behaviour: ['Default', 'MovistarMenu']
    mainOptions: null,
    navSections: null,
    segmentMenu: null,
    burgerSections: null,
    burgerOptions: null,
    fixedMenu: exports.DEFAULT_FIXED,
    showNotificationsIcon: false,
    querySuggestedInputs: null,
    inputQuery: '',
    categoriesMatched: null,
    suggestedInputs: null,
    pagesList: null,
    pagesSuggestedList: null,
    // FOOTER
    footerInfo: null,
};
const HeaderReducer = (state = exports.initialState, action) => {
    switch (action.type) {
        case HYDRATE: {
            const { header } = action.payload;
            /* neceisto preservar lo que viene del sever excepto los filtros */
            const nextState = (0, deepmerge_1.default)(state, header);
            return nextState;
        }
        case exports.types.SETUP_HEADER_PROPS: {
            const headerProps = action.data;
            return Object.assign(Object.assign({}, state), headerProps);
        }
        case exports.types.SET_HEADER_LOCATION:
            return Object.assign(Object.assign({}, state), { location: action.location });
        case exports.types.SET_SEARCHER_INFO:
            return Object.assign(Object.assign({}, state), { pagesList: (action.info && action.info.pagesList) || null, querySuggestedInputs: null, suggestedInputs: (action.info && action.info.suggestedInputs) || null, categoryOptions: (action.info && action.info.categoryOptions) || null });
        case exports.types.SET_SUGGESTED_INPUTS: {
            return Object.assign(Object.assign({}, state), { querySuggestedInputs: [...action.data.querySuggestedInputs] });
        }
        case exports.types.RESET_SEARCHER: {
            return Object.assign(Object.assign({}, state), { categoriesMatched: null, querySuggestedInputs: null, pagesSuggestedList: null });
        }
        case exports.types.SET_RELATED_PAGES: {
            return Object.assign(Object.assign({}, state), { inputQuery: action.data.inputQuery, categoriesMatched: action.data.categoriesMatched, pagesSuggestedList: Object.assign({}, action.data.pagesList) });
        }
        case exports.types.SET_SECTION_MENU:
            return Object.assign(Object.assign({}, state), { sectionMenu: action.payload });
        case exports.types.SET_MOVISTAR_MENU:
            return Object.assign(Object.assign({}, state), { movistarMenuInfo: action.payload });
        case exports.types.SET_SECTION_MENU_EMP:
            return Object.assign(Object.assign({}, state), { sectionMenuEmp: action.payload });
        case exports.types.SET_MOVISTAR_MENU_EMP:
            return Object.assign(Object.assign({}, state), { movistarMenuInfoEmp: action.payload });
        case exports.types.SET_FOOTER_INFO:
            return Object.assign(Object.assign({}, state), { footerInfo: action.footerInfo });
        default:
            return Object.assign({}, state);
    }
};
exports.actions = {
    setupHeaderProps: (data) => ({
        type: exports.types.SETUP_HEADER_PROPS,
        data,
    }),
    /* operations */
    setHeaderLocation: (location) => ({
        type: exports.types.SET_HEADER_LOCATION,
        location,
    }),
    /* pikolin */
    getHeaderInfo: (data) => ({ type: exports.types.GET_HEADER_INFO, data }),
    setSectionMenu: (data) => ({ type: exports.types.SET_SECTION_MENU, payload: data }),
    setMovistarMenu: (data) => ({ type: exports.types.SET_MOVISTAR_MENU, payload: data }),
    setSectionMenuEmp: (data) => ({
        type: exports.types.SET_SECTION_MENU_EMP,
        payload: data,
    }),
    setMovistarMenuEmp: (data) => ({
        type: exports.types.SET_MOVISTAR_MENU_EMP,
        payload: data,
    }),
    /* + alla */
    getFooterInfo: (data) => ({ type: exports.types.GET_FOOTER_INFO, data }),
    setFooterInfo: (footerInfo) => ({ type: exports.types.SET_FOOTER_INFO, footerInfo }),
    /* searcher */
    setSearchEngine: (searchEngine) => ({
        type: exports.types.SET_SEARCH_ENGINE,
        searchEngine,
    }),
    resetSearcher: () => ({ type: exports.types.RESET_SEARCHER }),
    // apis
    getSearcherInfo: () => ({ type: exports.types.GET_SEARCHER_INFO }),
    setSearcherInfo: (info) => ({ type: exports.types.SET_SEARCHER_INFO, info }),
    // js logic
    setSuggestedInputs: (data) => ({ type: exports.types.SET_SUGGESTED_INPUTS, data }),
    getRelatedPages: (query) => ({ type: exports.types.GET_RELATED_PAGES, query }),
    setRelatedPages: (data) => ({ type: exports.types.SET_RELATED_PAGES, data }),
};
exports.default = HeaderReducer;
//# sourceMappingURL=index.js.map